import { Reveal } from "@/components/Reveal";
import { ApplyButton } from "@/components/Buttons";

export const CTASection = ({
  headline = "Ready to stop being the best-kept secret in your market?",
  subhead = "We only take on a limited number of local clients at a time. Apply now and we'll tell you if we're a fit.",
}) => (
  <section className="relative z-10 bg-ink-900 border-t border-white/10" data-testid="cta-section">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 py-24 sm:py-32">
      <div className="relative overflow-hidden border border-gold/30 bg-gradient-to-br from-ink-800 to-ink-900 p-10 sm:p-16 lg:p-24">
        <div className="absolute -right-20 -top-20 w-72 h-72 rounded-full bg-gold/10 blur-3xl" />
        <div className="relative max-w-3xl">
          <Reveal>
            <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white leading-[1.05]">{headline}</h2>
          </Reveal>
          <Reveal delay={100}>
            <p className="mt-6 text-lg text-cream/70 max-w-2xl">{subhead}</p>
          </Reveal>
          <Reveal delay={200}>
            <div className="mt-10"><ApplyButton testid="cta-section-apply" /></div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default CTASection;
